import { create } from 'zustand';

interface RetirementStore {
  compoundFinalAmount: number | null;
  setCompoundFinalAmount: (amount: number) => void;
  retirementMonthlyExpense: number | null;
  setRetirementMonthlyExpense: (expense: number) => void;
}

export const useRetirementStore = create<RetirementStore>((set) => ({
  compoundFinalAmount: null,
  setCompoundFinalAmount: (amount) => set({ compoundFinalAmount: amount }),
  retirementMonthlyExpense: null,
  setRetirementMonthlyExpense: (expense) => set({ retirementMonthlyExpense: expense }),
}));
